module.exports = __webpack_public_path__ + "static/media/icon_checkbox_on.afa49c53.svg";